import { useState } from 'react'

import CloseIcon from '@/assets/icons/icon-close.svg'
import InfoIcon from '@/assets/icons/icon-info.svg'
import { Button } from '@/components/ui/button'
import {
  Popover,
  PopoverArrow,
  PopoverContent,
  PopoverTrigger,
} from '@/components/ui/popover'
import { LocalStorageKeys } from '@/consts/localStorage.ts'
import { DIALOG_TYPE } from '@/dialogs/constants'
import { openDialog } from '@/models/dialogs'
import { IconButton } from '@/modules/chatting/ui/components/icon-button'

const openIntroDialog = () => {
  openDialog({
    type: DIALOG_TYPE.CUI_INTRO,
  })
}

export const Introduction = () => {
  const [isOpen, setIsOpen] = useState(
    !localStorage.getItem(LocalStorageKeys.CHATTING_INTRODUCTION_SHOWN),
  )
  const handleCloseInfo = () => {
    setIsOpen(false)
    localStorage.setItem(LocalStorageKeys.CHATTING_INTRODUCTION_SHOWN, 'true')
  }

  return (
    <Popover open={isOpen}>
      <PopoverTrigger asChild>
        <IconButton
          icon={InfoIcon}
          onClick={openIntroDialog}
          iconClassName="h-7 w-7"
          tooltip="Chatting UI Introduction"
        />
      </PopoverTrigger>
      <PopoverContent className="z-50">
        <div className="flex w-full flex-col">
          <div className="flex items-start gap-2">
            <p className="text-sm">
              Click here to access the tutorial on using the Chatting UI
              anytime.
            </p>
            <IconButton
              onClick={handleCloseInfo}
              icon={CloseIcon}
              iconClassName="h-4 w-4"
            />
          </div>
          <Button
            type="button"
            variant="link"
            className="mr-auto p-0 text-sm text-blue-500"
            onClick={handleCloseInfo}
          >
            Got it
          </Button>
        </div>
        <PopoverArrow />
      </PopoverContent>
    </Popover>
  )
}
